export const namePdfOutputFile = (aplId: string): string => {
  return `${aplId}.pdf`;
};

export const namePdfOutputFileWithLabel = (aplId: string): string => {
  return `${aplId}_帳票.pdf`;
};
